import React from "react";
import { AmbientBackground } from "@/components/AmbientBackground";
import ExecuteSOP from "@/pages/ExecuteSOP";

/** Minimal chrome for iframe / kiosk / multi-device embed */
export default function EmbedExecute() {
  return (
    <div className="relative min-h-screen text-white">
      <AmbientBackground />
      <div className="relative z-10">
        <ExecuteSOP embed />
      </div>
    </div>
  );
}
